/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import { useRouter } from 'next/router';
import Logo from '@comp/Logo/Logo';
import Drawer from '@base/Drawer/Drawer';
import { breakpoints } from '@styles/index';
import Dynamic from '@base/Dynamic/Dynamic';
import { useToggleable } from '@stores/toggleables';
import { LOGIN_DRAWER } from '@constants/toggleables';
import { useState } from 'react';
import LoginComponent from '@cont/Login/LoginComponent';
import useShowLoginDrawerOnBatch from '@stores/showLoginDrawerOnBatch';
import HeaderContent from '../Components/HeaderParent';
import HeaderTop from '../Components/HeaderContainer';

const HeaderContainer = styled(HeaderTop)`
  height: 56px;
  position: initial;
`;

const HeaderParent = styled(HeaderContent)`
  height: 56px;
  @media only screen and (max-width: ${breakpoints.tablet}) {
    width: 768px;
    padding: 0px 20px;
  }
  @media only screen and (max-width: ${breakpoints.mobile}) {
    width: 100%;
    padding: 0 16px;
  }
`;

const DynamicLogin = Dynamic(() => import('@cont/Login/Login'));

const isSubscriptionPricingsUrl = (route) =>
  route === '/goal/[goalSlug]/[goalUID]/subscribe';

const Header = ({ className }) => {
  const { closeElement: closeLoginDrawer, isOpen: showLoginDrawer } =
    useToggleable(LOGIN_DRAWER);

  const { setShowLoginDrawer } = useShowLoginDrawerOnBatch();

  const router = useRouter();
  const { route } = router;
  const [backButton, setBackButton] = useState({
    value: false,
    fn: () => {}
  });

  const handleBackPress = () => {
    backButton.fn();
  };

  const isNewLoginUI = isSubscriptionPricingsUrl(route);

  const handleCloseLoginDrawer = () => {
    setShowLoginDrawer(false, '');
    closeLoginDrawer();
  };

  function renderLogin() {
    return isNewLoginUI ? (
      <LoginComponent
        loginProps={{
          setBackButton,
          backButton
        }}
        drawerProps={{
          login: true,
          drawerState: showLoginDrawer,
          onClose: handleCloseLoginDrawer,
          showBackButton: backButton.value,
          hideCloseButton: backButton.value,
          onPressBack: handleBackPress
        }}
      />
    ) : (
      <Drawer
        login
        drawerState={showLoginDrawer}
        onClose={closeLoginDrawer}
        showBackButton={backButton.value}
        hideCloseButton={backButton.value}
        onPressBack={handleBackPress}
      >
        <DynamicLogin setBackButton={setBackButton} backButton={backButton} />
      </Drawer>
    );
  }

  return (
    <HeaderContainer className={className}>
      <HeaderParent>
        <Logo disabled={!isSubscriptionPricingsUrl(route)} />
      </HeaderParent>
      {renderLogin()}
    </HeaderContainer>
  );
};

export default Header;

Header.propTypes = {};

Header.defaultProps = {
  isCheckoutUrl: false,
  isDarkModeOn: false,
  hideSearch: false,
  transparent: false,
  isLoginUrl: false
};
